import React from 'react';
import './App.css';
import {Route, Routes} from "react-router";
import Login from "./layouts/Login";
import Dashboard from "./layouts/Dashboard";
import Logout from "./layouts/Logout";
// import SignUp from "./layouts/SignUp";
import PhoneExtensions from './layouts/PhoneExtensions';
import ForgotPassword from "./layouts/ForgotPassword";
import ChangePassword from "./layouts/ChangePassword";

function App() {
  return (
      <Routes>
        <Route
            path={"/"}
            element={<Login />}
        />
        <Route
            path={"/login"}
            element={<Login />}
        />

          <Route
              path={"/reset-password"}
              element={<ForgotPassword />}
          />
          <Route
              path={"/changePassword/:token"}
              element={<ChangePassword />}
          />

        <Route
            path={"/dashboard"}
            element={<Dashboard/>}
        />

        <Route
            path='/ip-phones'
            element={<PhoneExtensions/>}
            />
        <Route
            path={"/logout"}
            element={<Logout />}
        />
          <Route
              path={"*"}
              element={<div>Page Not Found</div>}
          />
      </Routes>
  );
}

export default App;
